import AuthCurrentTenant from 'src/modules/auth/authCurrentTenant';
import authAxios from 'src/modules/shared/axios/authAxios';

export default class SettingsService {
  static applyThemeFromTenant() {
    // const currentSettings = AuthCurrentTenant.getSettings();

    // if (currentSettings) {
    //   const { theme, customColorOffice } = currentSettings;
    //   return this.applyTheme(theme, customColorOffice);
    // }

    // this.applyTheme('default');
  }

  static async find() {
    const tenantId = AuthCurrentTenant.get();

    const response = await authAxios.get(
      `/tenant/${tenantId}/settings`,
    );

    return response.data;
  }

  static async save(settings) {
    const body = {
      settings,
    };

    const tenantId = AuthCurrentTenant.get();
    const response = await authAxios.put(
      `/tenant/${tenantId}/settings`,
      body,
    );
    return response.data;
  }

  static applyTheme(color, _customColor = null) {
    // const oldLink = document.getElementById('theme-link');

    // if (oldLink) {
    //   oldLink.setAttribute(
    //     'href',
    //     `${process.env.PUBLIC_URL}/theme/dist/${color}.css`,
    //   );

    //   if (customColor) {
    //     oldLink.onload = function () {
    //       SettingsService.replaceColorInCSS(
    //         color,
    //         customColor,
    //       );
    //     };
    //   }
    //   return;
    // }

    // const link = document.createElement('link');
    // link.setAttribute('id', 'theme-link');
    // link.setAttribute('rel', 'stylesheet');
    // link.setAttribute('type', 'text/css');
    // link.setAttribute(
    //   'href',
    //   `${process.env.PUBLIC_URL}/theme/dist/${color}.css`,
    // );

    // const head = document.getElementsByTagName('head')[0];
    // if (!head) {
    //   return;
    // }
    // head.appendChild(link);

    // if (customColor) {
    //   link.onload = function () {
    //     SettingsService.replaceColorInCSS(
    //       color,
    //       customColor,
    //     );
    //   };
    // }
  }

  static replaceColorInCSS(color, newColor) {
    const storedCssKey = `custom-css-${color}-${newColor}`;
    const storedCss = localStorage.getItem(storedCssKey);

    if (storedCss) {
      SettingsService.applyCustomCSS(storedCss);
    } else {
      const oldLink: any =
        document.getElementById('theme-link');

      fetch(oldLink.href)
        .then((response) => response.text())
        .then((cssText) => {
          const updatedCssText = cssText.replace(
            /#1890ff/g,
            newColor,
          );
          localStorage.setItem(
            storedCssKey,
            updatedCssText,
          );
          SettingsService.applyCustomCSS(updatedCssText);
        })
        .catch((error) => {
          console.error(
            'Error fetching or updating CSS:',
            error,
          );
        });
    }
  }

  static applyCustomCSS(cssText) {
    let customStyle =
      document.getElementById('custom-theme');
    if (!customStyle) {
      customStyle = document.createElement('style');
      customStyle.setAttribute('id', 'custom-theme');
      document.head.appendChild(customStyle);
    }
    customStyle.innerHTML = cssText;
  }
}
